import {
    toLogin as browserToLogin,
    getSpotTradePath,
} from '@/utils/jumpLink';
import {
    jumpLogin as appToLogin,
    jumpTrade as appToTrade,
    openBrowser as appOpenBrowser,
    jumpVip as appToVip,
} from '@/utils/appBridge';
import { replaceDomainToLocation } from '@/utils/url';

export {
    getVoteRecodPath,
    getVoteHomePath,
    getVoteDetailPath,
    getVoteInstructionsPath,
} from '@/utils/jumpLink';

const { isApp } = window.sfe;
const downloadAppPath = replaceDomainToLocation(
    'https://app.bybit.com/download/download.html?utm_source=pchomepaged&utm_medium=picscann&utm_campaign=appdownload',
);

/**
 * 根据宿主环境，跳转对应登录页面
 */
export const toLogin = () => {
    if (isApp) {
        appToLogin().then(() => window.location.reload());
    } else {
        browserToLogin(window.location.href);
    }
};

/**
 * 打开第三方链接地址
 *
 * @param {string} url 页面链接
 */
export const openLink = (url) => {
    if (isApp) {
        appOpenBrowser(url);
    } else {
        const aTag = document.createElement('a');
        aTag.setAttribute('target', '_blank');
        aTag.setAttribute('href', url);
        document.body.appendChild(aTag);
        aTag.click();
        document.body.removeChild(aTag);
    }
};

/**
 * 跳转到下载APP页面
 */
export const toDownloadApp = () => openLink(downloadAppPath);

/**
 * 跳转到交易页
 *
 * @param {string} base 基础货币
 * @param {string} quote 计价货币
 */
export const toTrade = (base, quote) => {
    if (isApp) {
        appToTrade(base, quote);
    } else {
        openLink(getSpotTradePath(base, quote));
    }
};

/**
 * 跳转到 VIP 页面
 *
 * @param {string} locale 多语言
 */
export const toVip = (locale) => {
    if (isApp) {
        appToVip();
    } else {
        openLink(`/${locale}/VIPProgram/intro`);
    }
};
